import React from 'react';
import { useThemeMode } from '../hooks/useThemeMode';

// Brand lock-up: symbol (main-logo) + wordmark (minimalist-dark/light) side by side.
// Wordmark PNG has been auto-cropped to remove padding, so use a small positive gap.
const MainLogo = ({ height = 40, style = {} }) => {
  const { isDark } = useThemeMode();
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: height * 0.2,
        ...style,
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/logo/main-logo.png`}
        alt=""
        aria-hidden="true"
        style={{ height, width: height, objectFit: 'contain' }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/logo/${isDark ? 'minimalist-dark.png' : 'minimalist-light.png'}`}
        alt="InterNull"
        style={{ height: height * 0.7, objectFit: 'contain' }}
      />
    </span>
  );
};

// Backwards-compatible alias (was previously a separate wordmark-only render).
// Now renders the same full lock-up so the pair is always shown together.
const MinimalistDarkLogo = MainLogo;

export { MainLogo, MinimalistDarkLogo };
